import * as React from 'react';

import ToastsTrigger from '../core/Toasts/ToastsTrigger';
import { NotificationSeverity } from '../NotificationsWidget/queries';
import MyTaskSource from '../Source/MyTaskSource/MyTaskSource';
import type { TaskResponse } from '../TasksWidget/queries';
import { TaskStatus } from '../TasksWidget/queries';
import { Provider } from './MyTasksContext';

interface OuterProps {}

export interface MyTasksProviderState {}

export interface MyTasksProviderProps extends OuterProps {}

class MyTasksProvider extends React.PureComponent<React.PropsWithChildren<MyTasksProviderProps>, MyTasksProviderState> {
  getSeverity = (task: TaskResponse) => {
    switch (task.status) {
      case TaskStatus.CANCELLED:
        return NotificationSeverity.WARNING;
      case TaskStatus.FAILED:
        return NotificationSeverity.ERROR;
      default:
        return NotificationSeverity.INFO;
    }
  };

  getDisplayName = (task: TaskResponse) => {
    switch (task.status) {
      case TaskStatus.CANCELLED:
        return `${task.displayName} has been canceled.`;
      case TaskStatus.FAILED:
        if (task.result?.description) {
          return `${task.displayName} has failed due to: ${task.result.description}`;
        }

        return `${task.displayName} has failed.`;
      case TaskStatus.DONE:
        return `${task.displayName} has finished.`;
      default:
        return `${task.displayName} initiated.`;
    }
  };

  handleNewToast = (task: TaskResponse) => {
    ToastsTrigger.add({
      severity: this.getSeverity(task),
      message: this.getDisplayName(task),
      id: crypto.randomUUID(),
    });
  };

  render() {
    return (
      <MyTaskSource onTaskCreate={this.handleNewToast} onTaskTerminate={this.handleNewToast}>
        {(myTasks, helpers) => (
          <Provider
            value={{
              myTasks,
              myTaskHelpers: helpers,
            }}
          >
            {this.props.children}
          </Provider>
        )}
      </MyTaskSource>
    );
  }
}

export default MyTasksProvider;
